var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "v-application--is-ltr",
    attrs: {
      "id": "app",
      "data-app": ""
    }
  }, [_c('v-overlay', {
    attrs: {
      "value": _vm.authInitializing || _vm.appLoading,
      "absolute": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64",
      "color": "primary"
    }
  })], 1), _vm.isAuthenticated && !_vm.authInitializing && !_vm.$route.meta.requiresGuest && !_vm.$route.meta.hideLayout ? _c('MainLayout') : !_vm.authInitializing ? _c('router-view') : _vm._e(), _c('ConfirmationDialog', {
    attrs: {
      "show": _vm.confirmationDialog.show,
      "message": _vm.confirmationDialog.message,
      "title": _vm.confirmationDialog.title
    },
    on: {
      "confirm": _vm.handleConfirm,
      "cancel": _vm.handleCancel
    }
  }), _c('NotificationPermission'), _vm.enablePwaUpdateUi ? _c('PWAUpdateNotification') : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }